module.exports = __webpack_public_path__ + "static/media/icn-stdby-list.94a062f6.svg";